import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../pages/index/Index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Support',
    name: 'Support',
    component: () => import ('../pages/support/Support')
  },
  {
    path: '/Cooperation',
    name: 'Cooperation',
    component: () => import ('../pages/cooperation/Cooperation')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  routes
})

export default router
